import {
  ApiBlueprint,
  createApiFactory,
  configApiRef,
  discoveryApiRef,
  fetchApiRef,
  gitflicAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { doraMetricsApiRef } from '../api/types';
import { DoraMetricsClient } from '../api/DoraMetricsGitflicClient';
import { MockDoraMetricsClient } from '../api/MockDoraMetricsClient';

export const doraMetricsApiExtension = ApiBlueprint.make({
  name: 'dora-metrics',
  params: createApi =>
    createApi(
      createApiFactory({
        api: doraMetricsApiRef,
        deps: {
          configApi: configApiRef,
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          gitflicAuthApi: gitflicAuthApiRef,
        },
        factory: ({ configApi, discoveryApi, fetchApi, gitflicAuthApi }) => {
          const debug =
            configApi
              .getConfig('app')
              .getOptionalConfig('doraMetrics')
              ?.getOptionalBoolean('debug') ?? false;

          return debug
            ? new MockDoraMetricsClient()
            : new DoraMetricsClient({
                configApi,
                discoveryApi,
                fetchApi,
                gitflicAuthApi,
              });
        },
      }),
    ),
});
